import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08bf3260")

_pushScopeId("data-v-08bf3260")
const _hoisted_1 = {
  "aria-hidden": "true",
  class: "fixed inset-0 transition-opacity z-20",
  title: "overlay_for_confirm"
}
const _hoisted_2 = { class: "absolute z-0 inset-0 backdrop-filter backdrop-blur-xl" }
const _hoisted_3 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_4 = { class: "justify-center items-center" }
const _hoisted_5 = { class: "mt-4 text-center font-bold text-bp-light" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_default_spinner = _resolveComponent("default-spinner")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_default_spinner, {
            "show-spinner": _ctx.showSpinner,
            style: {"margin-top":"50%"},
            "show-spinner-alternative-text": "show-spinner-alternative-text",
            "spinner-color": _ctx.spinnerColor,
            "spinner-size": _ctx.spinnerSize
          }, null, 8, ["show-spinner", "spinner-color", "spinner-size"]),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.loadingText.length > 0 ? _ctx.loadingText : _ctx.$t("loading.FullScreenSpinner.loadingText")), 1)
        ])
      ])
    ])
  ]))
})